import "react";
import { jsx as e, jsxs as l } from "react/jsx-runtime";
var d = (o) => /* @__PURE__ */ e("svg", {
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...o,
  children: /* @__PURE__ */ l("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    children: [
      /* @__PURE__ */ e("path", {
        clipRule: "evenodd",
        d: "m7.414 20.414-3.828-3.828c-.375-.375-.586-.884-.586-1.414v-6.344c0-.53.211-1.039.586-1.414l3.828-3.828c.375-.375.884-.586 1.414-.586h6.343c.53 0 1.039.211 1.414.586l3.828 3.828c.376.375.587.884.587 1.414v6.343c0 .53-.211 1.039-.586 1.414l-4.414 4.415h-7.172c-.53 0-1.039-.211-1.414-.586z",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ e("path", { d: "m9 15 6-6" }),
      /* @__PURE__ */ e("path", { d: "m15 15-6-6" })
    ]
  })
});
export {
  d as default
};

//# sourceMappingURL=DeleteDisableHexagon.js.map